import {
  ENABLE_SELECTION,
  DISABLE_SELECTION,
  CLEAR_SELECTION_ITEMS,
  ADD_SELECTION_ITEMS,
  SELECT_ITEM,
  UNSELECT_ITEM,
  SELECT_ALL,
  UNSELECT_ALL
} from 'shared/actions/types';

export const enableSelection = (header, buttonText, buttonIcon, callback, cancel) => dispatch => {
  dispatch({
    type: ENABLE_SELECTION,
    payload: {
      header,
      buttonText,
      buttonIcon,
      callback,
      cancel
    }
  });
}

export const disableSelection = () => dispatch => {
  dispatch({
    type: DISABLE_SELECTION
  });
}

export const clearSelectionItems = items => dispatch => {
  dispatch({
    type: CLEAR_SELECTION_ITEMS
  });
}

export const addSelectionItems = items => dispatch => {
  dispatch({
    type: ADD_SELECTION_ITEMS,
    payload: items
  });
}

export const selectItem = item => dispatch => {
  dispatch({
    type: SELECT_ITEM,
    payload: item
  });
}

export const unselectItem = item => dispatch => {
  dispatch({
    type: UNSELECT_ITEM,
    payload: item
  });
}

export const selectAll = () => dispatch => {
  dispatch({
    type: SELECT_ALL
  });
}

export const unselectAll = () => dispatch => {
  dispatch({
    type: UNSELECT_ALL
  });
}
